<template>
  <d2-container>
    <h2>签章审核列表</h2>
    <!--筛选条件区域-->
    <el-form ref="elForm" :model="listQuery" size="medium" label-width="110px">
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="注册区县">
          <town-com v-on:on-selectLast="(e)=>listQuery.addressStreetId=e"></town-com>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-select v-model="listQuery.entType" placeholder="请选择企业类型" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in entTypeOptions" :key="index" :label="item.label" :value="item.value"
                       :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="start" align="top">
        <el-form-item  label="企业名称">
          <el-input v-model="listQuery.entName" placeholder="请输入企业名称"
                    clearable :style="{width: '545px'}"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
          <el-button size="small" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!--添加区域-->
    <!--表格分页列表-->
    <el-tabs v-model="listQuery.status" @tab-click="handleFilter">
      <el-tab-pane label="待审核" :name="1"></el-tab-pane>
      <el-tab-pane label="审核通过" :name="3"></el-tab-pane>
      <el-tab-pane label="审核不通过" :name="-1"></el-tab-pane>
    </el-tabs>
    <el-table :data="list" v-loading.body="listLoading" size="small" stripe
              highlight-current-row
              style="width: 100%">
      <el-table-column
              fixed
              type="selection"
              width="55" label="序号">
      </el-table-column>
      <el-table-column
              prop="date"
              label="企业名称"
              width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.enterprise.entName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="province"
          label="所属街镇"
          width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.enterprise.addressStreetName }}/{{ scope.row.enterprise.addressStreetDetail }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="city"
              label="法人代表"
              width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.enterprise.legalName }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="address"
              label="联系人">
        <template slot-scope="scope">
          <span>{{ scope.row.enterprise.contactName }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="signatureCount"
              label="可用签章数">
      </el-table-column>
      <el-table-column
              prop="signatureNum"
              label="申请签章数">
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态">
        <template slot-scope="scope">{{statusFun(scope.row.status)}}</template>
      </el-table-column>
      <el-table-column
              fixed="right"
              align="center"
              width="300"
              label="操作" v-if="listQuery.status==1">
        <template slot-scope="scope">
          <el-button size="small" type="success"  @click="handleUpdate(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </template>

    <!--表单添加更新区域-->
    <el-dialog :fullscreen="false" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form" label-width="150px">
        <el-form-item label="审核类型" prop="">
          <el-radio v-model="form.status" :label="3">审核通过</el-radio>
          <el-radio v-model="form.status" :label="2">驳回修改</el-radio>
        </el-form-item>
        <el-form-item label="驳回内容" prop="chargeType" v-if="form.status==2">
          <el-input v-model="form.auditContent" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" v-if="form.status==2" @click="form.auditContent='';update('form')">确定</el-button>
        <el-button type="primary" size="small" v-if="form.status==3" @click="update('form')">确定</el-button>
        <el-button @click="cancel('form')" size="small">取 消</el-button>
      </div>
    </el-dialog>

  </d2-container>
</template>


<script>
  import {
    pageList,
    addObj,
    delObj,
    getObj,
    putObj,
  } from '@/api/admin/sysEnterpriseSignature/index';
    import uploadComponent from '../common/upload-com.vue'
    import TownCom from "../common/town-com.vue";
    import {mapGetters} from 'vuex';
    export default {
        name: 'sysEnterpriseSignature',
        components: {
            uploadComponent, TownCom
        },
        data() {
            return {
                listQuery: {
                    page: 1,
                    limit: 20,
                    status: 1,
                    entName: null,
                    entType: null,
                    addressStreetId: null,
                },
                entTypeOptions: [{
                    "label": "加油",
                    "value": 0
                }, {
                    "label": "供油",
                    "value": 1
                }],

                list: null,
                total: null,
                listLoading: true,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                form:{
                    countyName:null,
                    type: null,
                }
            }
        },
        /**
         * 创建实例执行
         */
        created() {
        },
        mounted() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ]),
        },
        methods: {
            statusFun(status){
              if(status==0 || status==2){
                return "已驳回";
              }else if(status==1){
                return "等待审核";
              }else if(status==3){
                return "通过";
              }else if(status==-1){
                return "不通过";
              }
              return "";
            },
            getList() {
                this.listLoading = true;
                this.listQuery.statusList = [this.listQuery.status];
                pageList({...this.listQuery}).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
                this.listLoading = false;
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
                this.selectCtry(-1, 2);
            },
            handleUpdate(row) {
                getObj(row.qzId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.qzId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },

            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        console.log(this.form);
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '操作成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleOpen(row) {
                this.enterpriseId = row.qzId;
                if(row.status==0){
                    this.$nextTick(()=>{
                        const entOpen = this.$refs.entOpen;
                        entOpen.restTemp();
                        entOpen.initOpen();
                    })
                }else if(row.status==4){//查询开通记录信息
                    let param = {};
                    param.qzId = this.enterpriseId;
                    rejectOpenDetail(param).then(result => {
                        this.initRejectOpenDetailObj = result;
                        console.log(this.initRejectOpenDetailObj);
                        this.$nextTick(()=>{
                            const entOpen = this.$refs.entOpen;
                            entOpen.restTemp();
                            entOpen.initRejectOpenDetail();
                        })
                    })
                }

                this.dialogOpenFormVisible = true;
            },
            handleClick(row) {
                let param = {};
                param.qzId = row.qzId;
                enterpriseDetail(param).then(result => {
                    if (result.statusCode == 200) {
                        this.enterpriseDetailObj = result.data;
                        this.enterpriseDetailObj.status = row.status;
                        this.$nextTick(()=>{
                            const detail = this.$refs.entDetail;
                            detail.initDetail();
                        })
                        this.toExamineVisible = true
                        ;
                    } else {
                        this.$notify({
                            title: '查询详情失败',
                            message: '查看详情失败',
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
            },
            resetTemp() {
                // this.contractFile = undefined,
                this.form = {

                };
            },
            resetForm() {
                this.listQuery = {
                  page: 1,
                  limit: 20,
                  status: "1",
                  entName: null,
                  entType: null,
                  addressStreetId: null,
                };
                this.areaOptions = [];
            },
        }
    }
</script>

